import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { truckService } from '../api/api';
import { formatPortalDate } from '../utils/dateFormat';

export default function ServiceAttentionNotice({ truckId, onOpenServiceLog }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!truckId) {
      setItems([]);
      return undefined;
    }
    let active = true;
    setLoading(true);
    truckService.getServiceAttention(truckId)
      .then((response) => active && setItems(Array.isArray(response.data) ? response.data : []))
      .catch(() => active && setItems([]))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [truckId]);

  if (!truckId || (!loading && items.length === 0)) return null;

  return (
    <Alert severity="warning" icon={<PriorityHighIcon />} sx={{ border: '1px solid #f5c66a', bgcolor: '#fff9e8', alignItems: 'flex-start' }}>
      <Typography sx={{ fontWeight: 900, color: '#7c4a03' }}>Attention from a previous service</Typography>
      {loading ? (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.75 }}><CircularProgress size={16} /><Typography variant="body2">Checking unresolved repair images…</Typography></Stack>
      ) : (
        <Stack spacing={1} sx={{ mt: 0.75 }}>
          {items.map((item) => (
            <Box key={item.id} sx={{ p: 1, borderRadius: 1.5, bgcolor: 'rgba(255,255,255,.72)', border: '1px solid rgba(245,158,11,.28)' }}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.75} alignItems={{ sm: 'center' }} justifyContent="space-between">
                <Box>
                  <Stack direction="row" spacing={0.75} alignItems="center" sx={{ flexWrap: 'wrap' }}>
                    <Chip size="small" color="warning" label="Follow-up required" sx={{ fontWeight: 800 }} />
                    <Typography variant="caption" sx={{ fontWeight: 800 }}>{item.service_date ? formatPortalDate(item.service_date) : 'Previous service'}</Typography>
                  </Stack>
                  <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 800 }}>{item.service_item || item.description || item.service_done || 'Repair image requires attention.'}</Typography>
                  {item.follow_up_instructions && <Typography variant="body2">{item.follow_up_instructions}</Typography>}
                </Box>
                {onOpenServiceLog && <Button size="small" variant="outlined" color="warning" onClick={() => onOpenServiceLog(item.service_log_id)}>Review</Button>}
              </Stack>
            </Box>
          ))}
        </Stack>
      )}
    </Alert>
  );
}
